import { getCurrentDate } from "../../../utils/dateFormat";

const SEARCH_FIELDS = [
  "productName",
  "firmName",
  "beatName",
  "orderNo",
  "orderDate",
  "outletUom",
  "rate",
];

export const getInitialState = (props) => ({
  dynamicMasterData: {
    areaDetail: props.areaList?.area,
    beatDetail: props.beatList?.beatByUserType ?? [],
    outletDetail: props.outletList?.outlets ?? [],
  },
  showCheckRecord: false,
  billwithOffer: false,
  outletIds: [],
  selection: [],
  billDate: getCurrentDate(),
  billDiscountPercentage: 0,
  dataTotal: 0,
  discountAmt: 0,
  totalAmt: 0,
  offerBillData: [],
  productStockData: {},
  flag: true,
  stockListForValidation: [],
  searchValue: "",
  searchBy: "0",
  searhFlag: 1,
  formData: {},
  fieldData: { flag: "0" },
  openProductList: false,
  isLostOrder: false,
  isLostOrderFlag: false,
  stockProductData: [],
});

export const filterTableData = (tableData, searchValue) => {
  if (!tableData || tableData.length === 0) {
    return tableData || [];
  }

  const query = (searchValue ?? "").trim().toLowerCase();
  if (!query) {
    return tableData;
  }

  return tableData.filter((currentRow) =>
    SEARCH_FIELDS.some((field) => {
      const value = currentRow[field];
      return value && value.toString().toLowerCase().includes(query);
    }),
  );
};

const buildStockMeta = (stockItem) => ({
  stakeholderRate: stockItem.product.rate,
  isRateWiseError: false,
  uomConversionValue: stockItem.product.uomConversionValue,
});

const buildOrderWithStock = (order, stockItem, includeStakeholderMeta) => {
  const closingQty = stockItem.secondaryClosingQty;
  const stockMeta = includeStakeholderMeta ? buildStockMeta(stockItem) : {};

  if (closingQty <= 0) {
    return {
      ...order,
      secondaryClosingQty: 0,
      disabled: true,
      checked: false,
      orderQty: 0,
      ...stockMeta,
    };
  }

  if (closingQty <= order.orderQty) {
    const orderObject = {
      ...order,
      productStock: 0,
      secondaryClosingQty: 0,
      disabled: true,
      checked: true,
      orderQty: closingQty,
      ...stockMeta,
    };
    stockItem.secondaryClosingQty = 0;
    return orderObject;
  }

  const orderObject = {
    ...order,
    productStock: closingQty - order.orderQty,
    secondaryClosingQty: closingQty,
    disabled: true,
    checked: true,
    orderQty: order.orderQty,
    ...stockMeta,
  };
  stockItem.secondaryClosingQty = closingQty - order.orderQty;
  return orderObject;
};

export const mergeOrdersWithStock = (
  response,
  productStocks,
  { includeStakeholderMeta = false } = {},
) => {
  const rowData = [];
  const stockLength = productStocks.length;

  const stockByProductId = new Map();
  for (let i = 0; i < stockLength; i++) {
    const stockItem = productStocks[i];
    stockByProductId.set(stockItem.product.id, stockItem);
  }

  response.forEach((order) => {
    if (stockLength === 0) {
      rowData.push({
        ...order,
        secondaryClosingQty: 0,
        disabled: true,
        checked: false,
        orderQty: 0,
      });
      return;
    }

    const stockItem = stockByProductId.get(order.product);

    if (!stockItem) {
      return;
    }

    rowData.push(buildOrderWithStock(order, stockItem, includeStakeholderMeta));
  });

  return rowData;
};

export const buildNegativeProductRows = (outletOrderDetail) => {
  const rows = [];

  outletOrderDetail.forEach((orderData) => {
    if (!orderData.checked || orderData.billQty > orderData.orderQty) {
      rows.push({
        index: rows.length + 1,
        id: orderData.id,
        firmName: orderData.firmName,
        beatName: orderData.beatName,
        orderNo: orderData.orderNo,
        orderDate: orderData.orderDate,
        productName: orderData.productName,
        outletUom: orderData.outletUom,
        billQty: orderData.billQty - orderData.orderQty,
      });
    }
  });

  return rows;
};

export const buildBillingPayload = ({
  outletOrderDetail,
  flag,
  productStockData,
}) => {
  const billingCheckedList = flag
    ? outletOrderDetail.filter((row) => row.checked && +row.orderQty > 0)
    : outletOrderDetail.filter((row) => row.checked);

  const stockList = flag
    ? productStockData.productStocks.map((stockObject) => ({
        productId: stockObject.product.id,
        stock: stockObject.secondaryClosingQty,
      }))
    : [];

  if (flag) {
    localStorage.setItem("stockList", JSON.stringify(stockList));
  }

  const billingDataToSave = billingCheckedList.map((billingObject) => ({
    outletOrderDetail: { id: billingObject.id },
    outLet: { id: billingObject.outlet },
    product: { id: billingObject.product },
    rate: +billingObject.rate,
    qty: +billingObject.orderQty,
    freeQty: +billingObject.freeQty,
    itemDiscPer: +billingObject.discountPer,
    conversionValue: +billingObject.uomConversionRate,
  }));

  return {
    dtoOutletBillDetails: billingDataToSave,
    productAndStocks: stockList,
  };
};

const hasOutletBillHeader = (billObject) =>
  billObject.outletBillHeader &&
  Object.keys(billObject.outletBillHeader).length !== 0 &&
  Array.isArray(billObject.outletBillHeader.outletBillDetails);

export const mapOfferBillResponse = (data) =>
  data.map((billObject) => {
    const afterOffers = billObject.outletBillsAfterApplyingOffers;
    if (!afterOffers?.outletBillDetails?.length) {
      return billObject;
    }

    if (!hasOutletBillHeader(billObject)) {
      return billObject;
    }

    const newBillObject = {
      ...afterOffers,
      outletBillDetails: afterOffers.outletBillDetails.map((orderObject) => {
        const productWithoutBillObject =
          billObject.outletBillHeader.outletBillDetails.filter(
            (row) => row.id == orderObject.id,
          );

        if (productWithoutBillObject.length !== 0) {
          return {
            ...orderObject,
            taxableAmtWithoutOffer: productWithoutBillObject[0].taxableAmt,
            totalAmtWithoutOffer: productWithoutBillObject[0].totalAmt,
          };
        }

        return {
          ...orderObject,
          taxableAmtWithoutOffer: 0.0,
          totalAmtWithoutOffer: 0.0,
        };
      }),
    };

    return {
      ...billObject,
      outletBillsAfterApplyingOffers: newBillObject,
    };
  });

export const syncMasterDataFromProps = (prevProps, nextProps, currentState) => {
  let dynamicMasterData = currentState.dynamicMasterData;
  let changed = false;

  if (
    prevProps.beatList?.beatByUserType !== nextProps.beatList?.beatByUserType
  ) {
    dynamicMasterData = {
      ...dynamicMasterData,
      beatDetail: nextProps.beatList?.beatByUserType ?? [],
    };
    changed = true;
  }

  if (prevProps.outletList?.outlets !== nextProps.outletList?.outlets) {
    dynamicMasterData = {
      ...dynamicMasterData,
      outletDetail: nextProps.outletList?.outlets ?? [],
    };
    changed = true;
  }

  if (
    prevProps.salesExecutive?.salesExecutive !==
    nextProps.salesExecutive?.salesExecutive
  ) {
    dynamicMasterData = {
      ...dynamicMasterData,
      salesPersonDetail: nextProps.salesExecutive?.salesExecutive ?? [],
    };
    changed = true;
  }

  return changed ? dynamicMasterData : currentState.dynamicMasterData;
};
